import { isMobileBrowser } from '../../../react/features/base/environment/utils';
import { JitsiConferenceEvents } from '../../../react/features/base/lib-jitsi-meet';
import StateListenerRegistry from '../../../react/features/base/redux/StateListenerRegistry';
import {
    updateRemoteParticipantFromPresence
} from '../../components/wildix-remote-control/action.any';
import {
    DISCO_WILDIX_REMOTE_CONTROL_FEATURE
} from '../../components/wildix-remote-control/constants';
import Env from '../../modules/Environment';

StateListenerRegistry.register(
    state => state['features/base/conference'].joining,
    (joining, { dispatch }) => {
        if (!joining) {
            return;
        }
        joining.on(JitsiConferenceEvents.USER_JOINED, (id, user) => {
            dispatch(updateRemoteParticipantFromPresence(user));
        });
    });


StateListenerRegistry.register(
    state => state['features/base/connection'].connection,
    connection => {
        if (!_isRemoteControlSupport()) {
            connection?.addFeature(DISCO_WILDIX_REMOTE_CONTROL_FEATURE, true);
        }
    });

function _isRemoteControlSupport() {
    return isMobileBrowser() || Env.isWizyconf() || navigator.product === 'ReactNative';
}
